import React, { useEffect, useState } from "react";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import AddUpdModal from "./AddUpdModal";
import PreviewPDF from "../../../helpers/previewPDF";
import {
  getRouteConfigs,
  resourcesDeposits,
  resourcesOperators,
  resourcesPayroll,
  resourcesUnits,
} from "../../../helpers/backend_helper";
import { DestroyAlertHelper, Alert } from "../../../helpers/alerts/alertHelper";
import { getStorageUser } from "../../../helpers/api_helper";
import { Button, Col, Container } from "reactstrap";
import ButtonHelper from "../../../helpers/ButtonHelper";
import FilesListHelper from "../../../helpers/FilesListHelper";
import * as dayjs from "dayjs";
import ConfigModal from "./ConfigModal";
import PeriodFilterHelper from "../../../helpers/PeriodFilterHelper";

const Nomina = () => {
  let timeElapsed = new Date();
  const [selects, setSelects] = useState({ operators: [], units: [] });
  const authUser = getStorageUser();
  const [pending, setPending] = useState(false);
  const [price, setPrice] = useState(null);
  const [salario, setSalario] = useState(null);
  const [descuento, setDescuento] = useState(null);
  const [primaDominical, setPrimaDominical] = useState(null);
  const [modal, setModal] = useState({ show: false, update: false });
  const [modalPdf, setModalPdf] = useState({ show: false, update: false });
  const [modalPrice, setModalPrice] = useState({ show: false, update: false });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "key",
    order: "asc",
    companySession: authUser.company_id,
    initDate: dayjs().startOf("month").format('YYYY-MM-DD'),
    endDate: dayjs().startOf("month").add(14, 'days').format('YYYY-MM-DD'),
  });
  const [items, setItems] = useState([]);
  const itemBase = {
    id: null,
    date: null,
    unit_id: null,
    notes: null,
    amount: null,
    total: null,
    operator_id: null,
    unit_id: null,
    salidas_count: null,
  };
  const [item, setItem] = useState(itemBase);

  useEffect(() => {
    let params = { params: filters };
    setPending(true);
    resourcesPayroll("get", params).then((response) => {
      setItems(response.data);
      setDataPag(response.meta);
      setPending(false);
    });
  }, [filters]);

  const addUpd = (row) => {
    console.log("row", row);
    if (row?.id) {
      setItem({
        ...row,
        date: dayjs(row.date.substr(0, 10)).format("YYYY-MM-DD"),
      });
      setModal({ ...modal, show: true, update: true });
    } else {
      setItem({ ...itemBase });
      setModal({ ...modal, show: true, update: false });
    }
  };

  const print = (row) => {
    const params = {params:{initDate: filters.initDate, endDate: filters.endDate},headers:{'Accept': 'application/pdf'},responseType: "blob",}
    resourcesPayroll("show", params, row.id).then((response) => {
      let nombre = "Archivo";
      var reader = new FileReader();
      reader.readAsDataURL(response);
      reader.fileName = nombre[1] || nombre[0];
      reader.onloadend = function (name) {
        name = nombre[0];
        var base64data = reader.result;
        setModalPdf({ show: true, update: false, url: base64data });
      };
    })
  };

  const getReports = (type) => {
    let config = {
      params: filters,
      headers: {
        Accept:
          type == 2
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    };
    resourcesPayroll("get", config).then((response) => {
      if (type == 1) {
        const url = URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Nominas.xlsx");
        document.body.appendChild(link);
        link.click();
      } else {
        let nombre = "Archivo";
        var reader = new FileReader();
        reader.readAsDataURL(response);
        reader.fileName = nombre[1] || nombre[0];
        reader.onloadend = function (name) {
          name = nombre[0];
          var base64data = reader.result;
          setModalPdf({ show: true, update: false, url: base64data });
        };
      }
    });
  };

  useEffect(() => {
    const fetchConfigs = async () => {
      const response = await getRouteConfigs();
      const salaryConf = response.filter((e) => e.configuration_id == 15);
      setSalario(salaryConf[0]?.value ?? 0);
      const descuentoIMSSConf = response.filter(
        (e) => e.configuration_id == 16
      );
      setDescuento(descuentoIMSSConf[0]?.value ?? 0);
      const primaDominicalConf = response.filter(
        (e) => e.configuration_id == 17
      );
      setPrimaDominical(primaDominicalConf[0]?.value ?? 0);
    };

    fetchConfigs();
  }, []);

  const completeConfigHandler = () =>{
    setFilters({...filters})
  }

  const columns = Columns(print);
  document.title = "Nómina | Sistema de logística";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              filterInp={false}
              tittle="Nómina"
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
              pagination={true}
            >
              <div className="mb-3">
                <ButtonHelper
                  actionSave={addUpd}
                  addButon={false}
                  reportButons={true}
                  actionReportButon={getReports}
                  actionAddButon={() => addUpd()}
                >
                  <Button
                    className="btn-sm float-end me-2"
                    type="button"
                    value={"Config"}
                    onClick={(e) =>
                      setModalPrice({ ...modalPrice, show: true })
                    }
                  >
                    <i className="fa fa-cogs"></i> Configurar
                  </Button>
                </ButtonHelper>
              </div>
              <PeriodFilterHelper
                setFilters={setFilters}
                filters={filters}
                modal={modalPdf}
                setModal={setModalPdf}
              />
              
              <Col xs={4} md={2} className="text-center">
                <span className="text-muted">Salario<br />Diario</span>
                <h4>${salario}</h4>
              </Col>
              <Col xs={4} md={2} className="text-center">
                <span className="text-muted">Factor de <br />descuento IMSS</span>
                <h4>{descuento * 100}%</h4>
              </Col>
              <Col xs={4} md={2} className="text-center">
                <span className="text-muted">Prima<br />Dominical</span>
                <h4>{primaDominical * 100}%</h4>
              </Col>
            </DataTableHelper>
          </div>
        </Container>
        {modalPdf.show && (
          <PreviewPDF title="Recibo de Nómina" modalPdf={modalPdf} setModalPdf={setModalPdf} />
        )}
        {modalPrice.show && salario != null && (
          <ConfigModal
            modal={modalPrice}
            setModal={setModalPrice}
            salario={salario}
            setSalario={setSalario}
            descuento={descuento}
            setDescuento={setDescuento}
            primaDominical={primaDominical}
            setPrimaDominical={setPrimaDominical}
            completeHandler={completeConfigHandler}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default Nomina;
